<template>
  <div class="layout-move-group-dialog">
    <div class="kye-dialog-body">
      <p class="title">被移动文件名称：{{dialogData.title}}</p>
      <div class="list-menu-list">
        <div class="list-item"
          :class="{'list-item-active': activeGroup && (activeGroup.id === item.id)}"
          v-for="item in dialogData.groupList"
          :key="item.id"
          @click="handleGroupClick(item)">
          <div class="list-item-content">
            <i class="list-item-prefix el-icon-message"></i>{{item.groupName}}
          </div>
        </div>
      </div>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary" @click="submit">保存</kye-button>
      <kye-button  @click="cancel">取消</kye-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      dialogData: Object,
    },
    data() {
      return {
        activeGroup: null
      }
    },
    // created () {
    //   if (this.dialogData) {
    //     Object.assign(this.formModel, this.dialogData)
    //   }
    // },
    methods: {
      async submit () {
        try {
          const url = 'system.homeIndex.move'
          const params = {
            ...this.dialogData,
            moduleGroupId: this.activeGroup.id
          }

          await this.$http(url, params)
          this.$message.success('保存成功')
          this.$emit('update')
          this.$emit('close')
        } catch (error) {
          console.error(error)
        }
      },
      cancel () {
        this.$emit('close')
      },
      handleGroupClick (item) {
        this.activeGroup = item
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-move-group-dialog {
  .title {
    font-size: 13px;
    color: #333333;
    // font-weight: bold;
    margin-bottom: 12px;
  }
  .list-menu-list {
    border: 1px solid #E9E8ED;
    border-radius: 4px;
    padding: 12px;
   .list-item {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .list-item-content {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      i {
        &.list-item-prefix {
          margin-right: 4px;
          color: #666666;
        }
        &.list-item-suffix {
          color: var(--g-color-primary);
          margin-left: 4px;
          visibility: hidden;
        }
      }

      &:hover {
        background: #F1F1F5;
        color: #FF9300;
        .list-item-suffix {
          visibility: visible;
          color: #FF9300;
        }
        .list-item-prefix {
          color: #FF9300;
        }
      }
      &-active {
        background: #F1F1F5;
        color: #FF9300;
        .list-item-suffix {
          visibility: visible;
          color: #FF9300 !important;
        }
        .list-item-prefix {
          color: #FF9300 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/move-group-dialog.vue